/* Minha Kidz: hover add, native Shopify cart sharing, truthful low-stock, verified announcements. */
(()=>{
  'use strict';
  const $=(s,r=document)=>r.querySelector(s);
  const $$=(s,r=document)=>Array.from(r.querySelectorAll(s));
  const notify=(msg)=>{ if(typeof window.showToast==='function')window.showToast(msg);else{const el=$('[data-toast]');if(el){el.textContent=msg;el.hidden=false;setTimeout(()=>{el.hidden=true},3400)}} };

  // Avoid a nested add-to-cart form inside the link or an unnecessary Quick View roundtrip.
  document.addEventListener('click',async e=>{
    const btn=e.target.closest('[data-mk-instant-add]');
    if(!btn)return;
    e.preventDefault();e.stopPropagation();
    if(btn.disabled)return;
    const variantId=btn.dataset.variantId;
    if(!/^\d+$/.test(variantId||''))return;
    const original=btn.innerHTML;btn.disabled=true;btn.setAttribute('aria-busy','true');
    try{
      const res=await fetch((window.Shopify?.routes?.root||'/')+'cart/add.js',{
        method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({items:[{id:Number(variantId),quantity:1}]})
      });
      if(!res.ok){const data=await res.json().catch(()=>({}));throw Error(data.description||'Could not add the product');}
      notify('Added to your bag');
      const cartButton=$('[data-cart-open]');
      if(cartButton)cartButton.click();else location.assign('/cart');
    }catch(error){notify(error.message||'Sorry, please try again.');}
    finally{btn.disabled=false;btn.removeAttribute('aria-busy');btn.innerHTML=original;}
  });

  // Same product inventory data Shopify uses for checkout. Never invent quantities or time limits.
  function updateStock(){
    const form=$('[data-product-form]'),select=$('[data-variant-select]',form||document),stock=$('[data-mk-stock-alert]');
    if(!form||!stock)return;
    const option=select?.selectedOptions?.[0];
    const qty=Number(option?.dataset.stock);
    const real=option?.dataset.stockManaged==='true' && option?.dataset.stockPolicy==='deny' && option?.dataset.available==='true';
    const show=Boolean(real&&Number.isInteger(qty)&&qty>0&&qty<=5);
    stock.hidden=!show;
    if(show){
      const msg=$('[data-mk-stock-message]',stock),fill=$('[data-mk-stock-fill]',stock);
      if(msg)msg.textContent=`Only ${qty} ${qty===1?'piece':'pieces'} left — order soon`;
      if(fill)fill.style.width=`${Math.max(10,Math.min(100,qty/5*100))}%`;
    }
  }
  document.addEventListener('change',e=>{if(e.target.matches('[data-variant-select]'))updateStock()});
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',updateStock);else updateStock();
  document.addEventListener('shopify:section:load',updateStock);

  // Shopify's /cart/... permalink with storefront=true opens the exact variants and quantities
  // in the recipient's own storefront cart instead of opening checkout directly.
  async function makeShareLink(){
    const root=window.Shopify?.routes?.root||'/';
    const r=await fetch(root+'cart.js',{headers:{Accept:'application/json'}});
    if(!r.ok)throw Error('Could not read cart');
    const cart=await r.json();
    if(!cart.items?.length)throw Error('Your cart is empty. Add a product first.');
    const combined=new Map();
    for(const item of cart.items){
      const id=String(item.variant_id||item.id||'');const quantity=Number(item.quantity);
      if(!/^\d+$/.test(id)||!Number.isInteger(quantity)||quantity<=0)continue;
      combined.set(id,(combined.get(id)||0)+quantity);
    }
    if(!combined.size)throw Error('There are no items to share');
    const parts=[...combined.entries()].map(([id,quantity])=>`${id}:${quantity}`).join(',');
    const base=new URL(root+'cart/'+parts,location.origin);
    base.searchParams.set('storefront','true');
    if(base.href.length>2000)throw Error('This cart is too large for a single share link.');
    return base.href;
  }
  async function copyLink(url){
    if(navigator.clipboard?.writeText){await navigator.clipboard.writeText(url);return true;}
    return false;
  }
  document.addEventListener('click',async e=>{
    const btn=e.target.closest('[data-mk-share-cart]');
    if(!btn)return;
    e.preventDefault();
    if(btn.disabled)return;btn.disabled=true;
    const inDrawer=Boolean(btn.closest('[data-cart-drawer]'));
    const panel=inDrawer?null:$('[data-mk-share-panel]'),field=panel?$('[data-mk-share-url]',panel):null,status=panel?$('[data-mk-share-message]',panel):null;
    try{
      const link=await makeShareLink();
      if(panel&&field){panel.hidden=false;field.value=link;field.focus();field.select();if(status)status.textContent='Link ready. Copy it to share.';}
      else if(navigator.share){try{await navigator.share({title:'Minha Kidz — my shopping bag',url:link});}catch(err){if(err.name!=='AbortError')throw err;}}
      else if(await copyLink(link)){notify('Cart link copied');}
      else{window.prompt('Copy your cart link:',link);}
    }catch(error){if(status){panel.hidden=false;status.textContent=error.message;}else notify(error.message||'Could not share cart.');}
    finally{btn.disabled=false;}
  });
  document.addEventListener('click',async e=>{
    const btn=e.target.closest('[data-mk-copy-cart]');if(!btn)return;
    const link=$('[data-mk-share-url]')?.value,status=$('[data-mk-share-message]');if(!link)return;
    try{if(await copyLink(link)){if(status)status.textContent='Copied! Send it to anyone you like.';}
      else{$('[data-mk-share-url]')?.select();if(status)status.textContent='Select and copy the highlighted link.';}}
    catch(_){$('[data-mk-share-url]')?.select();if(status)status.textContent='Select and copy the highlighted link.';}
  });

  // Only display manually entered, confirmed real order events. No simulated customer purchases.
  function verifiedOrders(){
    const data=$('[data-mk-proof-json]'),box=$('[data-mk-proof-toast]');if(!data||!box)return;
    let orders=[];try{orders=JSON.parse(data.textContent||'[]')}catch(_){}
    orders=orders.filter(x=>x&&x.verified&&x.product&&x.title);
    if(!orders.length)return;
    const title=$('[data-mk-proof-title]',box),photo=$('[data-mk-proof-image]',box),location=$('[data-mk-proof-location]',box);
    let index=0,hideTimer;
    const show=()=>{
      if(document.hidden)return;
      const order=orders[index%orders.length];index++;
      title.textContent=order.title;
      if(photo){photo.src=order.image||'';photo.alt='';photo.hidden=!order.image;}
      if(location)location.textContent=order.location?`Purchased by a customer in ${order.location}`:'Verified customer purchase';
      box.hidden=false;clearTimeout(hideTimer);hideTimer=setTimeout(()=>box.hidden=true,7500);
    };
    let closed=false;
    $('[data-mk-proof-close]',box)?.addEventListener('click',()=>{box.hidden=true;closed=true;});
    setTimeout(()=>{if(!closed)show();},14000);
    setInterval(()=>{if(!closed)show();},42000);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',verifiedOrders);else verifiedOrders();
})();
